import type { SupabaseClient } from "@supabase/supabase-js";
import { createClient } from "@supabase/supabase-js";

let supabaseClient: SupabaseClient | null = null;

/**
 * Retorna o endpoint corporativo nativo (/api/v1).
 * Dessa forma, o nome 'supabase' e URLs externas são 100% eliminados do navegador.
 */
export const getSupabaseUrl = (): string => {
  if (typeof window !== "undefined" && window.location) {
    return `${window.location.origin}/api/v1`;
  }
  return "/api/v1";
};

export const getSupabaseClient = () => {
  if (!supabaseClient) {
    supabaseClient = createClient(getSupabaseUrl(), "dotus_crm_client_public", {
      auth: {
        storageKey: "dotus_crm_session",
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    });
  }
  return supabaseClient;
};
